import React from 'react'

function Footer() {
  return (
        <footer className="footer__area footer__style--1" id="contact">
            <div className="foooter__main">
                <div className="container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <div className="footer__widget">
                                <span className="title__sub"><i className="fas fa-envelope"></i>Send Us a Message</span>
                                <form className="contact__form" style={{marginTop:0}}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="input_field">
                                                <input type="text" placeholder="Enter your name*" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input_field">
                                                <input type="email" placeholder="Enter your email*" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input_field">
                                                <input type="number" placeholder="Enter your  number*" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input_field">
                                                <input type="text" placeholder="Subject*" />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="input_field">
                                                <textarea name="message" id="message" cols="30" rows="10" placeholder="Enter your Message*"></textarea>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <button className="thm_btn">submit Request</button>
                                        </div>
                                    </div>
                                </form>
                            </div>   
                        </div>
                        <div className="col-lg-6">
                            <div className="widget__wrap">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-12 col-md-6 widget__border">
                                        <div className="footer__widget">
                                            <span className="title__sub"><i className="fas fa-map-marker-alt"></i>Location</span>
                                            <h3 className="widget__title">Lagos, Nigeria</h3>
                                            <p>10, Sophie Kuye Street, Gbagada, Lagos</p>
                                            <p>Moday - Friday <br /> 08.00 AM - 05.00 PM</p>
                                            {/* <h5 className="address"><i className="fas fa-map-marker-alt"></i>Badda, Tangroad</h5> */}
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 col-md-6 widget__border">
                                        <div className="footer__widget">
                                            <span className="title__sub"><i className="fas fa-envelope"></i>Contact Info</span>
                                            <h3 className="widget__title">Other Channels</h3>
                                            <ul className="widget__info list-unstyled">
                                                <li><a href="tel:+2348127167973">(+234) 812 716 7973</a></li>
                                                <li><a href="mailto:info@ttnconsulting.com.ng">info@ttnconsulting.com.ng</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer__bottom pt-60 pb-60">
                <div className="container">
                    <div className="row align-items-center mt-none-15">
                        <div className="col-lg-3 col-md-3 mt-15">
                            <div className="logo">
                                <a href="#"><img src="assets/img/logo/logo.svg" alt="" /></a>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-9 mt-15">
                           <ul className="footer__nav ul_li_right">
                               <li><a href="#">Home </a></li>
                               <li><a href="#about">About</a></li>
                               <li><a href="#clients">Clients</a></li>
                               <li><a href="#services">Services</a></li>
                               <li><a href="#testimonial">Testimonial</a></li>
                               <li><a href="https://ttnconsulting.zohorecruit.com/jobs/Careers" target="_blank">Careers</a></li>
                           </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
  )
}

export default Footer
